import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { clientService } from "../services/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash, faSearch } from "@fortawesome/free-solid-svg-icons";
import toast from "react-hot-toast";

const Clients = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    nome: "",
    empresa: "",
    nif: "",
    zona: "",
    transporte: "",
  });

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    try {
      setLoading(true);
      const data = await clientService.getClients(filters);
      setClients(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Erro ao carregar clientes:", error);
      setClients([]);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSearch = () => {
    fetchClients();
  };

  const handleDeleteClient = async (id, nome) => {
    if (window.confirm(`Tem certeza que deseja deletar o cliente "${nome}"?`)) {
      try {
        await clientService.deleteClient(id);
        toast.success("Cliente deletado com sucesso");
        fetchClients();
      } catch (error) {
        toast.error(error.message || "Erro ao deletar cliente");
      }
    }
  };

  if (loading) {
    return (
      <div className="container-fluid p-4">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-4 sm:p-6 lg:p-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-neutral-800">
          Gestão de Clientes
        </h1>
        <Link
          to="/create-client"
          className="bg-neutral-900 text-white px-4 py-2 rounded-md hover:bg-neutral-800 flex items-center gap-2"
        >
          <FontAwesomeIcon icon={faPlus} />
          Novo Cliente
        </Link>
      </div>

      {/* Filtros */}
      <div className="bg-white shadow-md rounded-lg p-6 mb-6">
        <h2 className="text-lg font-semibold text-neutral-800 mb-4">Filtros</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          <div>
            <label className="block text-sm text-neutral-700 mb-2">Nome</label>
            <input
              type="text"
              name="nome"
              value={filters.nome}
              onChange={handleFilterChange}
              placeholder="Buscar por nome..."
              className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
            />
          </div>
          <div>
            <label className="block text-sm text-neutral-700 mb-2">Empresa</label>
            <input
              type="text"
              name="empresa"
              value={filters.empresa}
              onChange={handleFilterChange}
              placeholder="Buscar por empresa..."
              className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
            />
          </div>
          <div>
            <label className="block text-sm text-neutral-700 mb-2">Zona</label>
            <input
              type="text"
              name="zona"
              value={filters.zona}
              onChange={handleFilterChange}
              placeholder="Buscar por zona..."
              className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
            />
          </div>
          <div>
            <label className="block text-sm text-neutral-700 mb-2">NIF</label>
            <input
              type="text"
              name="nif"
              value={filters.nif}
              onChange={handleFilterChange}
              placeholder="Buscar por NIF..."
              className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
            />
          </div>
          <div>
            <label className="block text-sm text-neutral-700 mb-2">Transporte</label>
            <input
              type="text"
              name="transporte"
              value={filters.transporte}
              onChange={handleFilterChange}
              placeholder="Buscar por transporte..."
              className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
            />
          </div>
        </div>
        <div className="mt-4">
          <button
            onClick={handleSearch}
            className="bg-neutral-900 text-white px-4 py-2 rounded-md hover:bg-neutral-800 flex items-center gap-2"
          >
            <FontAwesomeIcon icon={faSearch} />
            Buscar
          </button>
        </div>
      </div>

      {/* Lista de clientes */}
      <div className="bg-white shadow-md rounded-lg overflow-hidden">
        {clients.length === 0 ? (
          <div className="p-6 text-center text-neutral-500">
            Nenhum cliente encontrado
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-neutral-50">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-medium text-neutral-700">
                    Nome
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-medium text-neutral-700">
                    Empresa
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-medium text-neutral-700">
                    NIF
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-medium text-neutral-700">
                    Zona
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-medium text-neutral-700">
                    Email
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-medium text-neutral-700">
                    Contacto
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-medium text-neutral-700">
                    Tipo Cliente
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-medium text-neutral-700">
                    Transporte
                  </th>
                  <th className="px-4 py-3 text-right text-sm font-medium text-neutral-700">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-neutral-200">
                {clients.map((client) => (
                  <tr key={client.id} className="hover:bg-neutral-50">
                    <td className="px-4 py-3 text-sm text-neutral-900">
                      {client.nome}
                    </td>
                    <td className="px-4 py-3 text-sm text-neutral-700">
                      {client.empresa || "-"}
                    </td>
                    <td className="px-4 py-3 text-sm text-neutral-700">
                      {client.nif || "-"}
                    </td>
                    <td className="px-4 py-3 text-sm text-neutral-700">
                      {client.zona || "-"}
                    </td>
                    <td className="px-4 py-3 text-sm text-neutral-700">
                      {client.email || "-"}
                    </td>
                    <td className="px-4 py-3 text-sm text-neutral-700">
                      {client.contacto || "-"}
                    </td>
                    <td className="px-4 py-3 text-sm text-neutral-700">
                      {client.tipo_cliente || "-"}
                    </td>
                    <td className="px-4 py-3 text-sm text-neutral-700">
                      {client.transporte || "-"}
                    </td>
                    <td className="px-4 py-3 text-right text-sm font-medium">
                      <div className="flex justify-end gap-2">
                        <Link
                          to={`/edit-client/${client.id}`}
                          className="text-blue-600 hover:text-blue-800"
                          title="Editar cliente"
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </Link>
                        <button
                          onClick={() => handleDeleteClient(client.id, client.nome)}
                          className="text-red-600 hover:text-red-800"
                          title="Deletar cliente"
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Clients;